<template>
  <div class="root">
    <b-container fluid>
      <b-row class="p-1">
        <b-col md="4"></b-col>
        <b-col md="4">
          <b-card variant="light" class=" mt-5 p-1 logwrap">
            <h6 v-html="signedupmsg"></h6>
            <p class="hsignup">Register</p>
            <form @submit.prevent="signupUser">
              <b-row>
                <b-col>
                  <b-form-group class="flabel" label-for="email">
                    <span class="label">Email</span>
                    <div class="form-input">
                      <b-input-group class="form-input" label-for="email">
                        <b-form-input
                          v-model="signup.email"
                          type="email"
                          id="email"
                          class="loginp p-2"
                          placeholder="user@example.com"
                          @input="emailExists()"
                          required
                        >
                        </b-form-input>
                      </b-input-group>
                    </div>
                    <div v-html="emsg"></div>
                  </b-form-group>

                  <b-form-group class="flabel" label-for="fname">
                    <span class="label">First Name</span>
                    <div class="form-input">
                      <b-input-group class="form-input" label-for="email">
                        <b-form-input
                          v-model="signup.fname"
                          type="text"
                          id="fname"
                          class="loginp p-3"
                          placeholder=""
                          required
                        >
                        </b-form-input>
                      </b-input-group>
                    </div>
                  </b-form-group>

                  <b-form-group class="flabel" label-for="lname">
                    <span class="label">Last Name</span>
                    <div class="form-input">
                      <b-input-group class="form-input" label-for="email">
                        <b-form-input
                          v-model="signup.lname"
                          type="text"
                          id="lname"
                          class="loginp p-3"
                          placeholder=""
                          required
                          @focus="setErr"
                        >
                        </b-form-input>
                      </b-input-group>
                    </div>
                  </b-form-group>

                  <b-form-group class="flabel" label-for="phone">
                    <span class="label">Phone Number</span>
                    <div class="form-input-2">
                      <vue-phone-number-input :show-code-on-list="true" :fetch-country="true" :no-example="true" size="sm" v-model="signup.phone" />
                    </div>
                  </b-form-group>

                  <b-form-group
                    class="nested-form-group"
                    label="Select Category"
                    label-for="institution"
                  >
                    <div class="form-input">
                      <b-input-group class="form-input" label-for="email">
                        <b-form-select v-model="signup.category">
                          <b-form-select-option value="null"
                            >--Select Category--</b-form-select-option
                          >
                          <b-form-select-option value="Individual"
                            >Individual</b-form-select-option
                          >
                          <b-form-select-option value="Organization"
                            >Organization</b-form-select-option
                          >
                        </b-form-select>
                      </b-input-group>
                    </div>
                  </b-form-group>

                  <div v-if="signup.category == 'Organization'">
                    <b-form-group class="flabel" label-for="fname">
                      <span class="label">Organization Name</span>
                      <b-form-input
                        v-model="signup.orgname"
                        type="text"
                        id="orgname"
                        class="loginp p-3"
                        placeholder=""
                        @input="orgnameExists()"
                        required
                      >
                      </b-form-input>
                      <div v-html="orgnameemsg"></div>
                    </b-form-group>

                    <b-form-group class="flabel" label-for="lname">
                      <span class="label">Organization Short Name</span><br />
                      <span style="fontSize: 0.6rem;color:red;"
                        >*Shortname can be an abbreviation or an acronym and
                        should be in CAPS</span
                      >
                      <b-form-input
                        v-model="signup.orgsname"
                        type="text"
                        id="orgsname"
                        class="loginp p-3"
                        placeholder=""
                        required
                        @input="orgsnameExists()"
                        @focus="setErr"
                      >
                      </b-form-input>
                      <div v-html="orgsnameemsg"></div>
                    </b-form-group>
                  </div>

                  <b-form-group class="flabel" label-for="pword">
                    <span class="label">Password</span>
                    <b-input-group v-if="showStar == true">
                      <b-form-input
                        v-model="signup.password"
                        type="password"
                        id="pword"
                        class="loginp p-3"
                        placeholder="***********"
                        required
                      >
                      </b-form-input>
                      <b-icon-eye-fill
                        font-scale="1.5"
                        class="close-button"
                        @click="
                          showText = true;
                          showStar = false;
                        "
                        variant="secondary"
                      ></b-icon-eye-fill>
                    </b-input-group>

                    <b-input-group v-if="showText == true">
                      <b-form-input
                        v-model="signup.password"
                        type="text"
                        id="pword"
                        class="loginp p-3"
                        placeholder=""
                        required
                      >
                      </b-form-input>
                      <b-icon-eye-slash-fill
                        font-scale="1.5"
                        class="close-button"
                        @click="
                          showText = false;
                          showStar = true;
                        "
                        variant="secondary"
                      ></b-icon-eye-slash-fill>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group class="flabel" label-for="cpword">
                    <span class="label">Confirm Password</span>
                    <b-input-group v-if="showStar2 == true">
                      <b-form-input
                        v-model="cpword"
                        type="password"
                        id="cpword"
                        class="loginp p-3"
                        placeholder="Password"
                        required
                        @input="confirmpword()"
                      >
                      </b-form-input>
                      <b-icon-eye-fill
                        font-scale="1.5"
                        class="close-button"
                        @click="
                          showText2 = true;
                          showStar2 = false;
                        "
                        variant="secondary"
                      ></b-icon-eye-fill>
                    </b-input-group>

                    <b-input-group v-if="showText2 == true">
                      <b-form-input
                        v-model="cpword"
                        type="text"
                        id="cpword"
                        class="loginp p-3"
                        placeholder="Confirm Password"
                        required
                        @input="confirmpword()"
                      >
                      </b-form-input>
                      <b-icon-eye-slash-fill
                        font-scale="1.5"
                        class="close-button"
                        @click="
                          showText2 = false;
                          showStar2 = true;
                        "
                        variant="secondary"
                      ></b-icon-eye-slash-fill>
                    </b-input-group>
                    
                  </b-form-group>
                  
                  <div class="alert-danger mb-4 mt-2" v-html="pworderr"></div>

                  <b-form-group
                    v-if="signup.category == 'Individual'"
                    class="flabel"
                    label-for="lname"
                  >
                    <span class="label">Referral Code (Optional)</span>
                    <div class="form-input">
                      <b-input-group class="form-input" label-for="email">
                        <b-form-input
                          v-model="signup.refcode"
                          type="text"
                          id="lname"
                          class="loginp p-3"
                          placeholder="xFtyUhgK"
                          @focus="setErr"
                        >
                        </b-form-input>
                      </b-input-group>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>

              <h6 v-html="signedupmsg"></h6>
              <b-row>
                <b-col md="3"></b-col>
                <b-col md="6">
                  <b-overlay
                    :show="signingup"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class=""
                  >
                    <b-button
                      :disabled="chkfields"
                      type="submit"
                      class="btn-md p-1 w-100"
                      variant="success"
                      >Sign Up</b-button
                    >
                  </b-overlay>

                  <b-button
                    v-if="signingup"
                    class="w-100 p-2 mt-3 btntxt"
                    variant="dark"
                    @click="stopproceed"
                  >
                    Cancel
                  </b-button>

                  <div class="be-links p-2">
                    Already have an account?
                    <b-link class="be-link" :to="{ name: 'login' }">
                      Sign in</b-link
                    ><br />
                  </div>
                  <!-- <div class="be-links text-center">
                      <p class="smalltext">or</p>
                      <b-button variant="light" class="smalltext gsign p-2 w-100"><img src="@/assets/google.png"> Sign up with Google</b-button>
                  </div> -->
                </b-col>
                <b-col md="3"></b-col>
              </b-row>
            </form>
          </b-card>
        </b-col>
        <b-col md="4"></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import store from "@/store";
//import NProgress from "nprogress";

export default {
  data() {
    return {
      signup: this.createSignup(),
      countdown: 5,
      signingup: false,
      frompath: "",
      emailexist: true,
      emsg: "",
      cpword: "",
      phoneerr: "",
      erronphone: true,
      erronpword: true,
      pworderr: "",
      signedupmsg: "",
      orgsnameemsg: "",
      orgsnameexist: true,
      orgnameemsg: "",
      orgnameexist: true,
      showStar: true,
      showText: false,
      showStar2: true,
      showText2: false
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("loginmaster/setOrigin");
    next();
  },
  created() {
    //this.$router.push(this.frompath)
    let now = new Date();
    now.setFullYear(now.getFullYear() - 10);
    document.cookie = `remember=;expires=${now.toUTCString()}`;
    document.cookie = `qid=;expires=${now.toUTCString()}`;

    if (this.$route.query.ref) {
      this.signup.refcode = this.$route.query.ref;
    }
  },

  updated() {},
  computed: {
    chkfields() {
      if (this.signup.category == "Individual") {
        if (
          this.emailexist ||
          this.erronpword ||
          this.signingup ||
          this.signup.fname.length <= 0 ||
          this.signup.phone.length <= 0 ||
          this.signup.lname.length <= 0 ||
          this.signup.email.length <= 0 ||
          this.signup.password.length <= 0
        ) {
          return true;
        } else {
          return false;
        }
      } else if (this.signup.category == "Organization") {
        if (
          this.emailexist ||
          this.orgsnameexist ||
          this.orgnameexist ||
          this.erronpword ||
          this.signingup ||
          this.signup.fname.length <= 0 ||
          this.signup.phone.length <= 0 ||
          this.signup.lname.length <= 0 ||
          this.signup.email.length <= 0 ||
          this.signup.orgname.length <= 0 ||
          this.signup.orgsname.length <= 0 ||
          this.signup.password.length <= 0
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    ...mapState({
      details: state => state.loginmaster.details,
      loggedin: state => state.loginmaster.loggedIn,
      ongoing: state => state.ongoing,
      start_config: state => state.exam.start_config,
      error: state => state.loginmaster.error,
      errmsg: state => state.loginmaster.errmsg,
      environ: state => state.loginmaster.environ,
      origin: state => state.loginmaster.site_origin
    })
  },
  methods: {
    emailExists() {
      let typingemail = this.signup.email;
      let regexpatt = /@+/;
      let isValid = regexpatt.test(typingemail);
      // alert(isValid)
      if (isValid) {
        return this.chkemail(this.signup.email).then(response => {
          this.emailexist = response.exists;
          this.emsg = response.msg;
        });
      } else {
        this.emsg = "";
      }
    },
    orgnameExists() {
      this.signup.orgname =
        this.signup.orgname.charAt(0).toUpperCase() +
        this.signup.orgname.slice(1);
      return this.chkorgname(this.signup.orgname).then(response => {
        this.orgnameexist = response.exists;
        this.orgnameemsg = response.msg;

        // console.log(response)
      });
    },
    orgsnameExists() {
      this.signup.orgsname = this.signup.orgsname.toUpperCase();
      return this.chkorgsname(this.signup.orgsname).then(response => {
        this.orgsnameexist = response.exists;
        this.orgsnameemsg = response.msg;
      });
    },
    validatephone() {
      this.phoneerr = "";
      let phone = this.signup.phone;
      var patt = /[a-z]+/i;

      if (patt.test(phone) || phone.length != 11) {
        this.phoneerr =
          "<ul class='alert alert-danger p-0 m-1'><li>Only numeric characters required</li>";
        this.phoneerr += "<li>Number must be 11 digits</li></ul>";
        this.erronphone = true;
      } else {
        this.phoneerr = "";
        this.erronphone = false;
      }
    },

    confirmpword() {
      let pword1 = this.signup.password;
      let pword2 = this.cpword;

      if (pword1 != pword2) {
        this.pworderr = "<b class='p-2'>Passwords do not match</b>";
        this.erronpword = true;
      } else if (pword1.length < 8) {
        this.pworderr =
          "<b class='p-2'>Password Length must be 8 or More Characters</b>";
        this.erronpword = true;
      } else {
        this.pworderr = "";
        this.erronpword = false;
      }
    },
    async signupUser() {
      this.setloader();

      this.signup.environ = this.environ;
      this.signup.origin = this.origin;

      //NProgress.start();
      return this.$store
        .dispatch("loginmaster/signUp", this.signup)
        .then(response => {
          this.signedupmsg = response.msg;
          this.signup.email = "";
          this.signup.fname = "";
          this.signup.lname = "";
          this.signup.orgname = "";
          this.signup.orgsname = "";
          this.signup.password = "";
          this.cpword = "";
          this.stopproceed();
          //console.log(response)
        })
        .catch(() => {
          this.$bvModal
            .msgBoxOk("Check your Network Connection. Could not Sign You Up.", {
              title: "No Network Connection",
              size: "xs",
              centered: true
            })
            .then(() => {
              this.logginin = false;
            });
          //console.log(error);
        });
    },
    createSignup() {
      return {
        email: "",
        fname: "",
        lname: "",
        phone: "",
        category: "Individual",
        orgname: "",
        orgsname: "",
        password: "",
        environ: "",
        origin: "",
        refcode: ""
      };
    },
    setloader() {
      this.signingup = true;
    },
    stopproceed() {
      this.signingup = false;
    },
    ...mapActions("loginmaster", [
      "setErr",
      "chkemail",
      "chkorgsname",
      "chkorgname"
    ])
  }
};
</script>

<style scoped>
.inpdiv {
  padding: 10px;
}

.sign-up {
  text-align: center;
  margin-top: 2rem;
}

.btn-md {
  font-size: 18px;
  font-weight: bold;
  color: white;
  background-color: #00984a;
  cursor: pointer;
}
.close-button {
  position: relative;
  left: -40px;
  top: 10px;
  cursor: pointer;
  z-index: 9999;
}
.flabel {
  font-size: 0.9rem;
  margin-top: -0.6rem;
}
.hsignup {
  font-weight: bolder;
  font-size: 1.3rem;
}
.label {
  font-size: 0.9rem;
}
.be-links {
  text-align: center;
  font-size: 0.7rem;
}
.be-link {
  color: #00984a;
}
.gsign {
  font-size: 0.8rem;
}
.form-input {
  width: 97%;
}

.form-input-2 {
  width: 94.5%;
}
</style>
